var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_buildings",
    "data-name": "vuesax/linear/buildings",
    transform: "translate(-364 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buildings",
    transform: "translate(364 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.708,11.083H2.375A2.1,2.1,0,0,1,0,8.708V2.375A2.1,2.1,0,0,1,2.375,0H6.333V8.708A2.1,2.1,0,0,0,8.708,11.083Z",
    transform: "translate(1.583 6.333)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.045,0a3.07,3.07,0,0,0-.087.792V3.167H0V1.583A1.588,1.588,0,0,1,1.583,0Z",
    transform: "translate(3.958 3.167)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0V3.958",
    transform: "translate(11.083 6.333)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0V3.958",
    transform: "translate(14.25 6.333)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.375,0H.792A.794.794,0,0,0,0,.792V3.958H3.167V.792A.794.794,0,0,0,2.375,0Z",
    transform: "translate(11.083 13.458)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0V3.167",
    transform: "translate(4.75 10.292)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,13.458V2.375A2.1,2.1,0,0,1,2.375,0h4.75A2.1,2.1,0,0,1,9.5,2.375V13.458a2.1,2.1,0,0,1-2.375,2.375H2.375A2.1,2.1,0,0,1,0,13.458Z",
    transform: "translate(7.917 1.583)",
    fill: "none",
    stroke: "#161617",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H19V19H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.c251a1f1c98dee2c7290ed9f142f2371.svg";
export { ForwardRef as ReactComponent };